
import pink from '@material-ui/core/colors/pink';
import teal from '@material-ui/core/colors/teal';
import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    primary: pink,
    secondary: teal,
  },
});
